import { useEffect } from 'react';

import { GameCommunicationBetSender } from '../../controllers/gameCommunication/senders/GameCommunicationBetSender';
import { useCoreDispatch } from '../../store/CoreStore';
import { useBetSlice } from '../../store/slices/bets/selectors';
import { betActions } from '../../store/slices/bets/slice';
import { useGameStateSlice } from '../../store/slices/game/selectors';

const betSender = new GameCommunicationBetSender();

export const useDragAndDropInit = (): void => {
  const dragBuffer = useBetSlice.getDragBuffer();
  const dispatch = useCoreDispatch();
  const isBetsOpenStatus = useGameStateSlice.isBetsOpenStatus();

  useEffect(() => {
    if (!isBetsOpenStatus) {
      dispatch(betActions.setDragBuffer(null));
      return;
    }
  }, [dispatch, isBetsOpenStatus]);

  useEffect(() => {
    const handleDocumentPointerUp = (): void => {
      if (dragBuffer?.preliminary === false) {
        dispatch(betActions.clearBet(dragBuffer.from));
        dispatch(betActions.setDragBuffer(null));
        betSender.dispatch();
      }
    };

    document.addEventListener('pointerup', handleDocumentPointerUp, { passive: true });

    return (): void => {
      document.removeEventListener('pointerup', handleDocumentPointerUp);
    };
  }, [dispatch, dragBuffer]);
};
